// LiveStreamChatroomMessage.js
import { connect } from 'react-redux';

import LiveStreamChatroomMessage from '../component/LiveStreamChatroomMessage.jsx';

import addvalue from '../action/addvalue.js';
import fetchUser from '../action/fetchUser.js';
import openBlockUserModal from '../action/openBlockUserModal.js';
import toggleModal from '../action/toggleModal.js';

import getMeBalance from '../selector/getMeBalance.js';
import getMeData from '../selector/getMeData.js';
import getUserData from '../selector/getUserData.js';
import getRankInLiveStream from '../selector/getRankInLiveStream.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getLivestreamChatData from '../selector/getLivestreamChatData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getModalData from '../selector/getModalData.js';
import getOperationData from '../selector/getOperationData.js';
import getVipLevelLivestreamChatStyle from '../selector/getVipLevelLivestreamChatStyle.js';
import { getMeSenderBadges } from '../selector/getUserBadges.js';
import { VIP_LEVEL_LIVESTREAM_NOTIFY_THRESHOLD } from '../RemoteConfigKeys.js';
import {
  getVipBenefitLevelThresholdByUserLevel,
  getUserLevelBenefitThresholdList,
} from '../selector/getUserLevelBenefitData.js';
import getVipLevelLivestreamStyleList from '../selector/getVipLevelLivestreamStyleList.js';

import {
  FEATURE_DISPLAY_NAME,
  FEATURE_MINI_PROFILE,
  LIVESTREAM_RATING_QUANTIZATION_STEP_SIZE,
} from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { chatMessageId, streamId }) => {
  const meId = getMeData(state, 'id');
  const senderId = getLivestreamChatData(
    state,
    [streamId, chatMessageId],
    'senderId'
  );
  const sessionId = getLiveStreamData(state, [streamId], 'sessionId');

  let senderUsername = '';
  let senderDisplayName = '';
  if (senderId === meId) {
    senderUsername = getMeData(state, 'username');
    senderDisplayName = getMeData(state, 'displayName');
  } else {
    senderUsername = getUserData(state, senderId, 'username');
    senderDisplayName = getUserData(state, senderId, 'displayName');
  }

  const isMiniBadgeInfoOpen = ['opening', 'display'].includes(
    getModalData(state, 'MiniBadgeInfoModal', 'status')
  );
  const isMiniProfileEnabled = getRemoteConfigData(state, FEATURE_MINI_PROFILE);
  const isDisplayNameEnabled = getRemoteConfigData(state, FEATURE_DISPLAY_NAME);
  const isStreamOwnerMessage = senderId === streamId;
  const isStreamOwner = meId === streamId;
  const rank = getRankInLiveStream(state, streamId, sessionId, senderId);

  const type = getLivestreamChatData(state, [streamId, chatMessageId], 'type');
  const text = getLivestreamChatData(state, [streamId, chatMessageId], 'text');
  const giftName = getLivestreamChatData(
    state,
    [streamId, chatMessageId],
    'giftName'
  );
  const giftKey = getLivestreamChatData(
    state,
    [streamId, chatMessageId],
    'giftKey'
  );
  const giftPrice = getLivestreamChatData(
    state,
    [streamId, chatMessageId],
    'giftPrice'
  );
  const giftDuration = getLivestreamChatData(
    state,
    [streamId, chatMessageId],
    'giftDuration'
  );
  const amount = getLivestreamChatData(
    state,
    [streamId, chatMessageId],
    'amount'
  );
  const diamonds = getLivestreamChatData(
    state,
    [streamId, chatMessageId],
    'diamonds'
  );
  const senderAvatarId = getLivestreamChatData(
    state,
    [streamId, chatMessageId],
    'senderAvatarId'
  );
  const senderLevel = getLivestreamChatData(
    state,
    [streamId, chatMessageId],
    'senderLevel'
  );
  const productId = getLivestreamChatData(
    state,
    [streamId, chatMessageId],
    'productId'
  );
  const senderBadges =
    getLivestreamChatData(state, [streamId, chatMessageId], 'senderBadges') ??
    (senderId === meId ? getMeSenderBadges(state) : undefined);
  const ratingStepSize = getRemoteConfigData(
    state,
    LIVESTREAM_RATING_QUANTIZATION_STEP_SIZE
  );

  const vipLevelLivestreamNotifyThreshold = getRemoteConfigData(
    state,
    VIP_LEVEL_LIVESTREAM_NOTIFY_THRESHOLD
  );
  const { vipBenefitLevel: minRequiredVipBenefitLevel } =
    getVipBenefitLevelThresholdByUserLevel(
      state,
      vipLevelLivestreamNotifyThreshold
    );
  const userLevelBenefitThresholdList = getUserLevelBenefitThresholdList(state);
  const maxVipBenefitLevel = userLevelBenefitThresholdList.at(-1)?.level ?? 0;
  const vipLevelLivestreamStyleList = getVipLevelLivestreamStyleList(
    state,
    minRequiredVipBenefitLevel,
    maxVipBenefitLevel
  );
  const { vipMessageLogStyle } = getVipLevelLivestreamChatStyle(
    state,
    senderLevel,
    minRequiredVipBenefitLevel,
    vipLevelLivestreamStyleList
  );

  const balance = getMeBalance(state);
  const hasEnoughBalance =
    typeof giftPrice === 'number' && balance >= giftPrice;

  return {
    streamId,
    senderId,
    senderUsername,
    senderDisplayName,
    isStreamOwnerMessage,
    isDisplayNameEnabled,
    isMiniProfileEnabled,
    isMiniBadgeInfoOpen,
    rank,
    type,
    text,
    giftName,
    giftKey,
    giftPrice,
    giftDuration,
    amount,
    diamonds,
    isStreamOwner,
    senderAvatarId,
    senderLevel,
    productId,
    senderBadges,
    deviceWidth: getOperationData(state, ['device'], 'width'),
    ratingStepSize,
    vipMessageLogStyle,
    vipLevelLivestreamNotifyThreshold,
    isAuthed: !!meId,
    hasEnoughBalance,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    openBlockUserModal: ({ userId }) =>
      dispatch(openBlockUserModal({ userId })),
    fetchUser: ({ senderId }) => dispatch(fetchUser({ id: senderId })),
    toggleModal: payload => dispatch(toggleModal(payload)),
    addvalue: payload => dispatch(addvalue(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStreamChatroomMessage);
